import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { inputCls } from "../components/ops/common";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please log in.");
      navigate("/portal");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#F8F9FA] min-h-[calc(100vh-73px)] flex items-center" data-testid="reset-password-page">
      <div className="max-w-md w-full mx-auto px-6">
        <div className="bg-white border border-border rounded-sm p-8">
          <span className="grid place-items-center w-12 h-12 rounded-sm bg-emerald/10 text-emerald mb-5"><ShieldCheck className="w-6 h-6" /></span>
          <h1 className="font-display text-2xl font-700 text-charcoal mb-2">Set a new password</h1>
          <p className="text-olive text-sm mb-6">Enter a new password for your account (minimum 6 characters).</p>
          {!token ? (
            <p className="text-red-600 text-sm" data-testid="reset-no-token">This reset link is invalid. <Link to="/portal" className="text-emerald underline">Back to login</Link></p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <input data-testid="reset-password-input" type="password" minLength={6} required value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="New password" className={inputCls} />
              <button type="submit" disabled={loading} data-testid="reset-submit-btn"
                className="w-full inline-flex items-center justify-center gap-2 bg-emerald text-white px-6 py-3 rounded-sm font-600 hover:bg-emerald-dark transition-colors disabled:opacity-60">
                {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Update Password"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
